import BaseController from "../base_controller"

export default class extends BaseController {
  static values = {
    delay: { type: Number, default: 0 }
  }

  connect() {
    this.timeout = null
    this.preventNextEvent = false
  }

  handleEvent(event) {
    if (this.delayValue > 0) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => this.submit(), this.delayValue)
    } else {
      this.submit()
    }
  }

  preventEvent(event) {
    event.preventDefault()
    this.preventNextEvent = true
  }

  submit() {
    if (this.preventNextEvent) {
      this.preventNextEvent = false
      return
    }

    this.element.requestSubmit()
  }
}
